import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { DepotItem } from './components/DepotItem'

type Props = RenderItemProps<'depots'>

export function Item(props: Props) {
  return props.type === 'item' ? <DepotItem {...props} /> : null
}
